import { LightningElement, api, wire } from "lwc";
import { EffectAdapter } from "common/effectAdapter";
import { LabelsAdapter } from "common/labelsAdapter";
import { assignedSlotNames } from "common/slot";
import { l as loadingStateLocales } from "tds/chunk_index2";

class contentCollectionLoadingState extends LightningElement {
  @api config = null;
  @api variant;
  state = "loaded";
  @wire(LabelsAdapter, {
    locales: loadingStateLocales,
  })
  labels = null;
  @wire(EffectAdapter, {
    config: "$config",
  })
  onConfigChange({ config }) {
    // TODO: Debounce state change to avoid flickering a loading state
    this.state = config.state;
    this.template.host.setAttribute("data-state", this.state);
  }
  get empty() {
    if (this.state !== "empty") return null;
    return {
      description: this.labels["empty.description"],
      iconSprite: "utility",
      iconSymbol: "trail",
      title: this.labels["empty.title"],
      ...this.config.empty,
    };
  }
  get emptyFallback() {
    return !this.slots.includes("empty");
  }
  get error() {
    if (this.state !== "error") return null;
    return {
      description: this.labels["error.description"],
      iconSprite: "utility",
      iconSymbol: "trail",
      refresh: true,
      refreshLabel: this.labels["error.refresh"],
      title: this.labels["error.title"],
      ...this.config.error,
    };
  }
  get errorFallback() {
    return !this.slots.includes("error");
  }
  get isLoaded() {
    return this.state === "loaded";
  }
  get loading() {
    if (this.state !== "loading") return null;
    return {
      stencilCount: 3,
      stencilVariant: "brick",
      ...this.config.loading,
    };
  }
  get loadingFallback() {
    return !this.slots.includes("loading");
  }
  slots = [];
  onRefresh() {
    this.setFocusOnRefresh();
    this.dispatchEvent(new CustomEvent("refresh"));
  }
  setFocusOnRefresh() {
    const refreshButton = this.template.querySelector(".state__refresh");
    if (refreshButton) {
      refreshButton.focus();
    } else {
      const logoAnchor = document.querySelector("[data-tracking-type=logo]");
      logoAnchor?.focus();
    }
  }
  onSlotChange() {
    this.slots = assignedSlotNames(this.template);
  }
}
function stateFromLearningCollection(items, error) {
  return error
    ? "error"
    : Array.isArray(items)
    ? items.length === 0
      ? "empty"
      : "loaded"
    : "loading";
}

export default contentCollectionLoadingState;
export { stateFromLearningCollection };
